<div class="loading_connect">
  <div class="cmsg">
      <div class="msg">
        <span nz-icon nzType="loading"> </span> Đang kết nối đến máy chủ ... Vui lòng chờ!
      </div>
  </div>
</div>
